type MaskFieldsType = '_password';
export function maskFieldInError(field: MaskFieldsType, errorDetails: any) {
    let errorStr = JSON.stringify(errorDetails, null, 4);
    // to avoid security warnings, we avoid using variables in regex
    if (field === '_password')
        errorStr = errorStr.replace(/(\\"_password\\":\\")([^"]*)(\\")/g, '$1************$3');
    return errorStr;
}
